import { axios } from '../libraries'

const api = axios.create({
  // baseURL: 'https://fevci.id/pehjGSZ/QtKOwrD/api'
 // baseURL: 'http://103.103.21.76/fevci/fevci-gateway'
	baseURL: "https://fevci.id/fevci/fevci-gateway"
  
})

export default api
